import dynamic from 'next/dynamic';
import { IconName } from './icon.types';

const About = dynamic(/* webpackChunkName: "chunkAboutIcon" */ import('./next/About'));
const Ac = dynamic(/* webpackChunkName: "chunkAcIcon" */ import('./next/Ac'));
const Accessible = dynamic(/* webpackChunkName: "chunkAccessibleIcon" */ import('./next/Accessible'));
const AccountFill = dynamic(/* webpackChunkName: "chunkAccountFillIcon" */ import('./next/AccountFill'));
const AccountStroke = dynamic(/* webpackChunkName: "chunkAccountStrokeIcon" */ import('./next/AccountStroke'));
const Active = dynamic(/* webpackChunkName: "chunkActiveIcon" */ import('./next/Active'));
const Activity = dynamic(/* webpackChunkName: "chunkActivityIcon" */ import('./next/Activity'));
const AddFamily = dynamic(/* webpackChunkName: "chunkAddFamilyIcon" */ import('./next/AddFamily'));
const AddTask = dynamic(/* webpackChunkName: "chunkAddTaskIcon" */ import('./next/AddTask'));
const Archive = dynamic(/* webpackChunkName: "chunkArchiveIcon" */ import('./next/Archive'));
const Arrow = dynamic(/* webpackChunkName: "chunkArrowIcon" */ import('./next/Arrow'));
const Article = dynamic(/* webpackChunkName: "chunkArticleIcon" */ import('./next/Article'));
const Arts = dynamic(/* webpackChunkName: "chunkArtsIcon" */ import('./next/Arts'));
const Award = dynamic(/* webpackChunkName: "chunkAwardIcon" */ import('./next/Award'));
const Awesome = dynamic(/* webpackChunkName: "chunkAwesomeIcon" */ import('./next/Awesome'));
const Bathing = dynamic(/* webpackChunkName: "chunkBathingIcon" */ import('./next/Bathing'));
const Bed = dynamic(/* webpackChunkName: "chunkBedIcon" */ import('./next/Bed'));
const Best = dynamic(/* webpackChunkName: "chunkBestIcon" */ import('./next/Best'));
const BestCare = dynamic(/* webpackChunkName: "chunkBestCareIcon" */ import('./next/BestCare'));
const Book = dynamic(/* webpackChunkName: "chunkBookIcon" */ import('./next/Book'));
const Business = dynamic(/* webpackChunkName: "chunkBusinessIcon" */ import('./next/Business'));
const BusinessFill = dynamic(/* webpackChunkName: "chunkBusinessFillIcon" */ import('./next/BusinessFill'));
const Cafe = dynamic(/* webpackChunkName: "chunkCafeIcon" */ import('./next/Cafe'));
const Calculate = dynamic(/* webpackChunkName: "chunkCalculateIcon" */ import('./next/Calculate'));
const Calendar = dynamic(/* webpackChunkName: "chunkCalendarIcon" */ import('./next/Calendar'));
const Cancel = dynamic(/* webpackChunkName: "chunkCancelIcon" */ import('./next/Cancel'));
const Care = dynamic(/* webpackChunkName: "chunkCareIcon" */ import('./next/Care'));
const Chair = dynamic(/* webpackChunkName: "chunkChairIcon" */ import('./next/Chair'));
const ChatFill = dynamic(/* webpackChunkName: "chunkChatFillIcon" */ import('./next/ChatFill'));
const ChatStroke = dynamic(/* webpackChunkName: "chunkChatStrokeIcon" */ import('./next/ChatStroke'));
const CheckCircleFill = dynamic(/* webpackChunkName: "chunkCheckCircleFillIcon" */ import('./next/CheckCircleFill'));
const CheckCircleStroke = dynamic(/* webpackChunkName: "chunkCheckCircleStrokeIcon" */ import('./next/CheckCircleStroke'));
const Checkbox = dynamic(/* webpackChunkName: "chunkCheckboxIcon" */ import('./next/Checkbox'));
const Checklist = dynamic(/* webpackChunkName: "chunkChecklistIcon" */ import('./next/Checklist'));
const Checkmark = dynamic(/* webpackChunkName: "chunkCheckmarkIcon" */ import('./next/Checkmark'));
const CheckmarkCircle = dynamic(/* webpackChunkName: "chunkCheckmarkCircleIcon" */ import('./next/CheckmarkCircle'));
const Chevron = dynamic(/* webpackChunkName: "chunkChevronIcon" */ import('./next/Chevron'));
const Church = dynamic(/* webpackChunkName: "chunkChurchIcon" */ import('./next/Church'));
const Close = dynamic(/* webpackChunkName: "chunkCloseIcon" */ import('./next/Close'));
const Clothes = dynamic(/* webpackChunkName: "chunkClothesIcon" */ import('./next/Clothes'));
const CommunitiesFill = dynamic(/* webpackChunkName: "chunkCommunitiesFillIcon" */ import('./next/CommunitiesFill'));
const CommunitiesStroke = dynamic(/* webpackChunkName: "chunkCommunitiesStrokeIcon" */ import('./next/CommunitiesStroke'));
const Compare = dynamic(/* webpackChunkName: "chunkCompareIcon" */ import('./next/Compare'));
const Compose = dynamic(/* webpackChunkName: "chunkComposeIcon" */ import('./next/Compose'));
const Concierge = dynamic(/* webpackChunkName: "chunkConciergeIcon" */ import('./next/Concierge'));
const Construction = dynamic(/* webpackChunkName: "chunkConstructionIcon" */ import('./next/Construction'));
const Contacts = dynamic(/* webpackChunkName: "chunkContactsIcon" */ import('./next/Contacts'));
const Contract = dynamic(/* webpackChunkName: "chunkContractIcon" */ import('./next/Contract'));
const Copy = dynamic(/* webpackChunkName: "chunkCopyIcon" */ import('./next/Copy'));
const Covid = dynamic(/* webpackChunkName: "chunkCovidIcon" */ import('./next/Covid'));
const DashboardFill = dynamic(/* webpackChunkName: "chunkDashboardFillIcon" */ import('./next/DashboardFill'));
const DashboardStroke = dynamic(/* webpackChunkName: "chunkDashboardStrokeIcon" */ import('./next/DashboardStroke'));
const DataFill = dynamic(/* webpackChunkName: "chunkDataFillIcon" */ import('./next/DataFill'));
const DataStroke = dynamic(/* webpackChunkName: "chunkDataStrokeIcon" */ import('./next/DataStroke'));
const Deck = dynamic(/* webpackChunkName: "chunkDeckIcon" */ import('./next/Deck'));
const Delete = dynamic(/* webpackChunkName: "chunkDeleteIcon" */ import('./next/Delete'));
const DiningRoom = dynamic(/* webpackChunkName: "chunkDiningRoomIcon" */ import('./next/DiningRoom'));
const Drag = dynamic(/* webpackChunkName: "chunkDragIcon" */ import('./next/Drag'));
const Drink = dynamic(/* webpackChunkName: "chunkDrinkIcon" */ import('./next/Drink'));
const Dropdown = dynamic(/* webpackChunkName: "chunkDropdownIcon" */ import('./next/Dropdown'));
const Edit = dynamic(/* webpackChunkName: "chunkEditIcon" */ import('./next/Edit'));
const Education = dynamic(/* webpackChunkName: "chunkEducationIcon" */ import('./next/Education'));
const Elevator = dynamic(/* webpackChunkName: "chunkElevatorIcon" */ import('./next/Elevator'));
const Emergency = dynamic(/* webpackChunkName: "chunkEmergencyIcon" */ import('./next/Emergency'));
const Entertainment = dynamic(/* webpackChunkName: "chunkEntertainmentIcon" */ import('./next/Entertainment'));
const Facebook = dynamic(/* webpackChunkName: "chunkFacebookIcon" */ import('./next/Facebook'));
const FactCheck = dynamic(/* webpackChunkName: "chunkFactCheckIcon" */ import('./next/FactCheck'));
const Family = dynamic(/* webpackChunkName: "chunkFamilyIcon" */ import('./next/Family'));
const FamilyFill = dynamic(/* webpackChunkName: "chunkFamilyFillIcon" */ import('./next/FamilyFill'));
const FamilyStroke = dynamic(/* webpackChunkName: "chunkFamilyStrokeIcon" */ import('./next/FamilyStroke'));
const Favorite = dynamic(/* webpackChunkName: "chunkFavoriteIcon" */ import('./next/Favorite'));
const Filter = dynamic(/* webpackChunkName: "chunkFilterIcon" */ import('./next/Filter'));
const Fireplace = dynamic(/* webpackChunkName: "chunkFireplaceIcon" */ import('./next/Fireplace'));
const Fitness = dynamic(/* webpackChunkName: "chunkFitnessIcon" */ import('./next/Fitness'));
const Flag = dynamic(/* webpackChunkName: "chunkFlagIcon" */ import('./next/Flag'));
const FloorPlan = dynamic(/* webpackChunkName: "chunkFloorPlanIcon" */ import('./next/FloorPlan'));
const Food = dynamic(/* webpackChunkName: "chunkFoodIcon" */ import('./next/Food'));
const Games = dynamic(/* webpackChunkName: "chunkGamesIcon" */ import('./next/Games'));
const Garage = dynamic(/* webpackChunkName: "chunkGarageIcon" */ import('./next/Garage'));
const Garden = dynamic(/* webpackChunkName: "chunkGardenIcon" */ import('./next/Garden'));
const Golf = dynamic(/* webpackChunkName: "chunkGolfIcon" */ import('./next/Golf'));
const Grill = dynamic(/* webpackChunkName: "chunkGrillIcon" */ import('./next/Grill'));
const GroupAdd = dynamic(/* webpackChunkName: "chunkGroupAddIcon" */ import('./next/GroupAdd'));
const HealthSafety = dynamic(/* webpackChunkName: "chunkHealthSafetyIcon" */ import('./next/HealthSafety'));
const Hearing = dynamic(/* webpackChunkName: "chunkHearingIcon" */ import('./next/Hearing'));
const HomeHealth = dynamic(/* webpackChunkName: "chunkHomeHealthIcon" */ import('./next/HomeHealth'));
const HomeHeart = dynamic(/* webpackChunkName: "chunkHomeHeartIcon" */ import('./next/HomeHeart'));
const HomeLarge = dynamic(/* webpackChunkName: "chunkHomeLargeIcon" */ import('./next/HomeLarge'));
const HomeMedium = dynamic(/* webpackChunkName: "chunkHomeMediumIcon" */ import('./next/HomeMedium'));
const HomeSmallFill = dynamic(/* webpackChunkName: "chunkHomeSmallFillIcon" */ import('./next/HomeSmallFill'));
const HomeSmallStroke = dynamic(/* webpackChunkName: "chunkHomeSmallStrokeIcon" */ import('./next/HomeSmallStroke'));
const Hourglass = dynamic(/* webpackChunkName: "chunkHourglassIcon" */ import('./next/Hourglass'));
const Housekeeping = dynamic(/* webpackChunkName: "chunkHousekeepingIcon" */ import('./next/Housekeeping'));
const Html = dynamic(/* webpackChunkName: "chunkHtmlIcon" */ import('./next/Html'));
const IceCream = dynamic(/* webpackChunkName: "chunkIceCreamIcon" */ import('./next/IceCream'));
const Image = dynamic(/* webpackChunkName: "chunkImageIcon" */ import('./next/Image'));
const Info = dynamic(/* webpackChunkName: "chunkInfoIcon" */ import('./next/Info'));
const Instagram = dynamic(/* webpackChunkName: "chunkInstagramIcon" */ import('./next/Instagram'));
const Kitchen = dynamic(/* webpackChunkName: "chunkKitchenIcon" */ import('./next/Kitchen'));
const Language = dynamic(/* webpackChunkName: "chunkLanguageIcon" */ import('./next/Language'));
const License = dynamic(/* webpackChunkName: "chunkLicenseIcon" */ import('./next/License'));
const Lightbulb = dynamic(/* webpackChunkName: "chunkLightbulbIcon" */ import('./next/Lightbulb'));
const Link = dynamic(/* webpackChunkName: "chunkLinkIcon" */ import('./next/Link'));
const Linkedin = dynamic(/* webpackChunkName: "chunkLinkedinIcon" */ import('./next/Linkedin'));
const List = dynamic(/* webpackChunkName: "chunkListIcon" */ import('./next/List'));
const Location = dynamic(/* webpackChunkName: "chunkLocationIcon" */ import('./next/Location'));
const Luxury = dynamic(/* webpackChunkName: "chunkLuxuryIcon" */ import('./next/Luxury'));
const Mail = dynamic(/* webpackChunkName: "chunkMailIcon" */ import('./next/Mail'));
const Map = dynamic(/* webpackChunkName: "chunkMapIcon" */ import('./next/Map'));
const Medication = dynamic(/* webpackChunkName: "chunkMedicationIcon" */ import('./next/Medication'));
const Memory = dynamic(/* webpackChunkName: "chunkMemoryIcon" */ import('./next/Memory'));
const Memory1 = dynamic(/* webpackChunkName: "chunkMemory1Icon" */ import('./next/Memory1'));
const Menu = dynamic(/* webpackChunkName: "chunkMenuIcon" */ import('./next/Menu'));
const Minus = dynamic(/* webpackChunkName: "chunkMinusIcon" */ import('./next/Minus'));
const Mobility = dynamic(/* webpackChunkName: "chunkMobilityIcon" */ import('./next/Mobility'));
const Money = dynamic(/* webpackChunkName: "chunkMoneyIcon" */ import('./next/Money'));
const MoneyFill = dynamic(/* webpackChunkName: "chunkMoneyFillIcon" */ import('./next/MoneyFill'));
const More = dynamic(/* webpackChunkName: "chunkMoreIcon" */ import('./next/More'));
const MoveIn = dynamic(/* webpackChunkName: "chunkMoveInIcon" */ import('./next/MoveIn'));
const Movie = dynamic(/* webpackChunkName: "chunkMovieIcon" */ import('./next/Movie'));
const Music = dynamic(/* webpackChunkName: "chunkMusicIcon" */ import('./next/Music'));
const Navigation = dynamic(/* webpackChunkName: "chunkNavigationIcon" */ import('./next/Navigation'));
const Night = dynamic(/* webpackChunkName: "chunkNightIcon" */ import('./next/Night'));
const Note = dynamic(/* webpackChunkName: "chunkNoteIcon" */ import('./next/Note'));
const NotificationFill = dynamic(/* webpackChunkName: "chunkNotificationFillIcon" */ import('./next/NotificationFill'));
const NotificationStroke = dynamic(/* webpackChunkName: "chunkNotificationStrokeIcon" */ import('./next/NotificationStroke'));
const Offer = dynamic(/* webpackChunkName: "chunkOfferIcon" */ import('./next/Offer'));
const Organization = dynamic(/* webpackChunkName: "chunkOrganizationIcon" */ import('./next/Organization'));
const OrganizationFill = dynamic(/* webpackChunkName: "chunkOrganizationFillIcon" */ import('./next/OrganizationFill'));
const Outdoors = dynamic(/* webpackChunkName: "chunkOutdoorsIcon" */ import('./next/Outdoors'));
const Parking = dynamic(/* webpackChunkName: "chunkParkingIcon" */ import('./next/Parking'));
const Pause = dynamic(/* webpackChunkName: "chunkPauseIcon" */ import('./next/Pause'));
const Payment = dynamic(/* webpackChunkName: "chunkPaymentIcon" */ import('./next/Payment'));
const People = dynamic(/* webpackChunkName: "chunkPeopleIcon" */ import('./next/People'));
const Percent = dynamic(/* webpackChunkName: "chunkPercentIcon" */ import('./next/Percent'));
const PersonCheck = dynamic(/* webpackChunkName: "chunkPersonCheckIcon" */ import('./next/PersonCheck'));
const Pets = dynamic(/* webpackChunkName: "chunkPetsIcon" */ import('./next/Pets'));
const Phone = dynamic(/* webpackChunkName: "chunkPhoneIcon" */ import('./next/Phone'));
const Pin = dynamic(/* webpackChunkName: "chunkPinIcon" */ import('./next/Pin'));
const PinCheckmark = dynamic(/* webpackChunkName: "chunkPinCheckmarkIcon" */ import('./next/PinCheckmark'));
const Play = dynamic(/* webpackChunkName: "chunkPlayIcon" */ import('./next/Play'));
const Plus = dynamic(/* webpackChunkName: "chunkPlusIcon" */ import('./next/Plus'));
const Policy = dynamic(/* webpackChunkName: "chunkPolicyIcon" */ import('./next/Policy'));
const Pool = dynamic(/* webpackChunkName: "chunkPoolIcon" */ import('./next/Pool'));
const Question = dynamic(/* webpackChunkName: "chunkQuestionIcon" */ import('./next/Question'));
const Quote = dynamic(/* webpackChunkName: "chunkQuoteIcon" */ import('./next/Quote'));
const Radio = dynamic(/* webpackChunkName: "chunkRadioIcon" */ import('./next/Radio'));
const RadioOutline = dynamic(/* webpackChunkName: "chunkRadioOutlineIcon" */ import('./next/RadioOutline'));
const Refresh = dynamic(/* webpackChunkName: "chunkRefreshIcon" */ import('./next/Refresh'));
const Religion = dynamic(/* webpackChunkName: "chunkReligionIcon" */ import('./next/Religion'));
const Restroom = dynamic(/* webpackChunkName: "chunkRestroomIcon" */ import('./next/Restroom'));
const Reviews = dynamic(/* webpackChunkName: "chunkReviewsIcon" */ import('./next/Reviews'));
const ReviewsFill = dynamic(/* webpackChunkName: "chunkReviewsFillIcon" */ import('./next/ReviewsFill'));
const Scissors = dynamic(/* webpackChunkName: "chunkScissorsIcon" */ import('./next/Scissors'));
const Search = dynamic(/* webpackChunkName: "chunkSearchIcon" */ import('./next/Search'));
const Sell = dynamic(/* webpackChunkName: "chunkSellIcon" */ import('./next/Sell'));
const Send = dynamic(/* webpackChunkName: "chunkSendIcon" */ import('./next/Send'));
const Seniorly = dynamic(/* webpackChunkName: "chunkSeniorlyIcon" */ import('./next/Seniorly'));
const SeniorlyLogo = dynamic(/* webpackChunkName: "chunkSeniorlyLogoIcon" */ import('./next/SeniorlyLogo'));
const SeniorlyLogoSren = dynamic(/* webpackChunkName: "chunkSeniorlyLogoSrenIcon" */ import('./next/SeniorlyLogoSren'));
const SentimentDissatisfied = dynamic(/* webpackChunkName: "chunkSentimentDissatisfiedIcon" */ import('./next/SentimentDissatisfied'));
const SentimentNeutral = dynamic(/* webpackChunkName: "chunkSentimentNeutralIcon" */ import('./next/SentimentNeutral'));
const SentimentSatisfied = dynamic(/* webpackChunkName: "chunkSentimentSatisfiedIcon" */ import('./next/SentimentSatisfied'));
const SettingsFill = dynamic(/* webpackChunkName: "chunkSettingsFillIcon" */ import('./next/SettingsFill'));
const SettingsStroke = dynamic(/* webpackChunkName: "chunkSettingsStrokeIcon" */ import('./next/SettingsStroke'));
const Share = dynamic(/* webpackChunkName: "chunkShareIcon" */ import('./next/Share'));
const SlyChat = dynamic(/* webpackChunkName: "chunkSlyChatIcon" */ import('./next/SlyChat'));
const SmokeDetector = dynamic(/* webpackChunkName: "chunkSmokeDetectorIcon" */ import('./next/SmokeDetector'));
const Spa = dynamic(/* webpackChunkName: "chunkSpaIcon" */ import('./next/Spa'));
const SqFt = dynamic(/* webpackChunkName: "chunkSqFtIcon" */ import('./next/SqFt'));
const Star = dynamic(/* webpackChunkName: "chunkStarIcon" */ import('./next/Star'));
const Stethoscope = dynamic(/* webpackChunkName: "chunkStethoscopeIcon" */ import('./next/Stethoscope'));
const Storage = dynamic(/* webpackChunkName: "chunkStorageIcon" */ import('./next/Storage'));
const Store = dynamic(/* webpackChunkName: "chunkStoreIcon" */ import('./next/Store'));
const Synagogue = dynamic(/* webpackChunkName: "chunkSynagogueIcon" */ import('./next/Synagogue'));
const Tech = dynamic(/* webpackChunkName: "chunkTechIcon" */ import('./next/Tech'));
const ThreeD = dynamic(/* webpackChunkName: "chunkThreeDIcon" */ import('./next/ThreeD'));
const Thumbs = dynamic(/* webpackChunkName: "chunkThumbsIcon" */ import('./next/Thumbs'));
const Time = dynamic(/* webpackChunkName: "chunkTimeIcon" */ import('./next/Time'));
const Transportation = dynamic(/* webpackChunkName: "chunkTransportationIcon" */ import('./next/Transportation'));
const Trend = dynamic(/* webpackChunkName: "chunkTrendIcon" */ import('./next/Trend'));
const Tv = dynamic(/* webpackChunkName: "chunkTvIcon" */ import('./next/Tv'));
const User = dynamic(/* webpackChunkName: "chunkUserIcon" */ import('./next/User'));
const Users = dynamic(/* webpackChunkName: "chunkUsersIcon" */ import('./next/Users'));
const UsersFill = dynamic(/* webpackChunkName: "chunkUsersFillIcon" */ import('./next/UsersFill'));
const Vaccines = dynamic(/* webpackChunkName: "chunkVaccinesIcon" */ import('./next/Vaccines'));
const Verified = dynamic(/* webpackChunkName: "chunkVerifiedIcon" */ import('./next/Verified'));
const Video = dynamic(/* webpackChunkName: "chunkVideoIcon" */ import('./next/Video'));
const Walk = dynamic(/* webpackChunkName: "chunkWalkIcon" */ import('./next/Walk'));
const Warning = dynamic(/* webpackChunkName: "chunkWarningIcon" */ import('./next/Warning'));
const Washer = dynamic(/* webpackChunkName: "chunkWasherIcon" */ import('./next/Washer'));
const Water = dynamic(/* webpackChunkName: "chunkWaterIcon" */ import('./next/Water'));
const Wifi = dynamic(/* webpackChunkName: "chunkWifiIcon" */ import('./next/Wifi'));
const X = dynamic(/* webpackChunkName: "chunkXIcon" */ import('./next/X'));
export const getIcon = (icon: IconName) => {
  switch(icon) {
    case 'About':
      return About;
    case 'Ac':
      return Ac;
    case 'Accessible':
      return Accessible;
    case 'AccountFill':
      return AccountFill;
    case 'AccountStroke':
      return AccountStroke;
    case 'Active':
      return Active;
    case 'Activity':
      return Activity;
    case 'AddFamily':
      return AddFamily;
    case 'AddTask':
      return AddTask;
    case 'Archive':
      return Archive;
    case 'Arrow':
      return Arrow;
    case 'Article':
      return Article;
    case 'Arts':
      return Arts;
    case 'Award':
      return Award;
    case 'Awesome':
      return Awesome;
    case 'Bathing':
      return Bathing;
    case 'Bed':
      return Bed;
    case 'Best':
      return Best;
    case 'BestCare':
      return BestCare;
    case 'Book':
      return Book;
    case 'Business':
      return Business;
    case 'BusinessFill':
      return BusinessFill;
    case 'Cafe':
      return Cafe;
    case 'Calculate':
      return Calculate;
    case 'Calendar':
      return Calendar;
    case 'Cancel':
      return Cancel;
    case 'Care':
      return Care;
    case 'Chair':
      return Chair;
    case 'ChatFill':
      return ChatFill;
    case 'ChatStroke':
      return ChatStroke;
    case 'CheckCircleFill':
      return CheckCircleFill;
    case 'CheckCircleStroke':
      return CheckCircleStroke;
    case 'Checkbox':
      return Checkbox;
    case 'Checklist':
      return Checklist;
    case 'Checkmark':
      return Checkmark;
    case 'CheckmarkCircle':
      return CheckmarkCircle;
    case 'Chevron':
      return Chevron;
    case 'Church':
      return Church;
    case 'Close':
      return Close;
    case 'Clothes':
      return Clothes;
    case 'CommunitiesFill':
      return CommunitiesFill;
    case 'CommunitiesStroke':
      return CommunitiesStroke;
    case 'Compare':
      return Compare;
    case 'Compose':
      return Compose;
    case 'Concierge':
      return Concierge;
    case 'Construction':
      return Construction;
    case 'Contacts':
      return Contacts;
    case 'Contract':
      return Contract;
    case 'Copy':
      return Copy;
    case 'Covid':
      return Covid;
    case 'DashboardFill':
      return DashboardFill;
    case 'DashboardStroke':
      return DashboardStroke;
    case 'DataFill':
      return DataFill;
    case 'DataStroke':
      return DataStroke;
    case 'Deck':
      return Deck;
    case 'Delete':
      return Delete;
    case 'DiningRoom':
      return DiningRoom;
    case 'Drag':
      return Drag;
    case 'Drink':
      return Drink;
    case 'Dropdown':
      return Dropdown;
    case 'Edit':
      return Edit;
    case 'Education':
      return Education;
    case 'Elevator':
      return Elevator;
    case 'Emergency':
      return Emergency;
    case 'Entertainment':
      return Entertainment;
    case 'Facebook':
      return Facebook;
    case 'FactCheck':
      return FactCheck;
    case 'Family':
      return Family;
    case 'FamilyFill':
      return FamilyFill;
    case 'FamilyStroke':
      return FamilyStroke;
    case 'Favorite':
      return Favorite;
    case 'Filter':
      return Filter;
    case 'Fireplace':
      return Fireplace;
    case 'Fitness':
      return Fitness;
    case 'Flag':
      return Flag;
    case 'FloorPlan':
      return FloorPlan;
    case 'Food':
      return Food;
    case 'Games':
      return Games;
    case 'Garage':
      return Garage;
    case 'Garden':
      return Garden;
    case 'Golf':
      return Golf;
    case 'Grill':
      return Grill;
    case 'GroupAdd':
      return GroupAdd;
    case 'HealthSafety':
      return HealthSafety;
    case 'Hearing':
      return Hearing;
    case 'HomeHealth':
      return HomeHealth;
    case 'HomeHeart':
      return HomeHeart;
    case 'HomeLarge':
      return HomeLarge;
    case 'HomeMedium':
      return HomeMedium;
    case 'HomeSmallFill':
      return HomeSmallFill;
    case 'HomeSmallStroke':
      return HomeSmallStroke;
    case 'Hourglass':
      return Hourglass;
    case 'Housekeeping':
      return Housekeeping;
    case 'Html':
      return Html;
    case 'IceCream':
      return IceCream;
    case 'Image':
      return Image;
    case 'Info':
      return Info;
    case 'Instagram':
      return Instagram;
    case 'Kitchen':
      return Kitchen;
    case 'Language':
      return Language;
    case 'License':
      return License;
    case 'Lightbulb':
      return Lightbulb;
    case 'Link':
      return Link;
    case 'Linkedin':
      return Linkedin;
    case 'List':
      return List;
    case 'Location':
      return Location;
    case 'Luxury':
      return Luxury;
    case 'Mail':
      return Mail;
    case 'Map':
      return Map;
    case 'Medication':
      return Medication;
    case 'Memory':
      return Memory;
    case 'Memory1':
      return Memory1;
    case 'Menu':
      return Menu;
    case 'Minus':
      return Minus;
    case 'Mobility':
      return Mobility;
    case 'Money':
      return Money;
    case 'MoneyFill':
      return MoneyFill;
    case 'More':
      return More;
    case 'MoveIn':
      return MoveIn;
    case 'Movie':
      return Movie;
    case 'Music':
      return Music;
    case 'Navigation':
      return Navigation;
    case 'Night':
      return Night;
    case 'Note':
      return Note;
    case 'NotificationFill':
      return NotificationFill;
    case 'NotificationStroke':
      return NotificationStroke;
    case 'Offer':
      return Offer;
    case 'Organization':
      return Organization;
    case 'OrganizationFill':
      return OrganizationFill;
    case 'Outdoors':
      return Outdoors;
    case 'Parking':
      return Parking;
    case 'Pause':
      return Pause;
    case 'Payment':
      return Payment;
    case 'People':
      return People;
    case 'Percent':
      return Percent;
    case 'PersonCheck':
      return PersonCheck;
    case 'Pets':
      return Pets;
    case 'Phone':
      return Phone;
    case 'Pin':
      return Pin;
    case 'PinCheckmark':
      return PinCheckmark;
    case 'Play':
      return Play;
    case 'Plus':
      return Plus;
    case 'Policy':
      return Policy;
    case 'Pool':
      return Pool;
    case 'Question':
      return Question;
    case 'Quote':
      return Quote;
    case 'Radio':
      return Radio;
    case 'RadioOutline':
      return RadioOutline;
    case 'Refresh':
      return Refresh;
    case 'Religion':
      return Religion;
    case 'Restroom':
      return Restroom;
    case 'Reviews':
      return Reviews;
    case 'ReviewsFill':
      return ReviewsFill;
    case 'Scissors':
      return Scissors;
    case 'Search':
      return Search;
    case 'Sell':
      return Sell;
    case 'Send':
      return Send;
    case 'Seniorly':
      return Seniorly;
    case 'SeniorlyLogo':
      return SeniorlyLogo;
    case 'SeniorlyLogoSren':
      return SeniorlyLogoSren;
    case 'SentimentDissatisfied':
      return SentimentDissatisfied;
    case 'SentimentNeutral':
      return SentimentNeutral;
    case 'SentimentSatisfied':
      return SentimentSatisfied;
    case 'SettingsFill':
      return SettingsFill;
    case 'SettingsStroke':
      return SettingsStroke;
    case 'Share':
      return Share;
    case 'SlyChat':
      return SlyChat;
    case 'SmokeDetector':
      return SmokeDetector;
    case 'Spa':
      return Spa;
    case 'SqFt':
      return SqFt;
    case 'Star':
      return Star;
    case 'Stethoscope':
      return Stethoscope;
    case 'Storage':
      return Storage;
    case 'Store':
      return Store;
    case 'Synagogue':
      return Synagogue;
    case 'Tech':
      return Tech;
    case 'ThreeD':
      return ThreeD;
    case 'Thumbs':
      return Thumbs;
    case 'Time':
      return Time;
    case 'Transportation':
      return Transportation;
    case 'Trend':
      return Trend;
    case 'Tv':
      return Tv;
    case 'User':
      return User;
    case 'Users':
      return Users;
    case 'UsersFill':
      return UsersFill;
    case 'Vaccines':
      return Vaccines;
    case 'Verified':
      return Verified;
    case 'Video':
      return Video;
    case 'Walk':
      return Walk;
    case 'Warning':
      return Warning;
    case 'Washer':
      return Washer;
    case 'Water':
      return Water;
    case 'Wifi':
      return Wifi;
    case 'X':
      return X;
    default:
      return Checkmark;
  }
}